export const CREATE_WORKER_ATTENDANCE_MONTHLY = 'CREATE_WORKER_ATTENDANCE_MONTHLY';
export const GET_WORKER_ATTENDANCE_MONTHLY = 'GET_WORKER_ATTENDANCE_MONTHLY';
export const WORKER_ATTENDANCE_MONTHLY_REQUEST = 'WORKER_ATTENDANCE_MONTHLY_REQUEST';
export const UPDATE_WORKER_ATTENDANCE_MONTHLY = 'UPDATE_WORKER_ATTENDANCE_MONTHLY';
export const DELETE_WORKER_ATTENDANCE_MONTHLY = 'DELETE_WORKER_ATTENDANCE_MONTHLY';
export const WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE = 'WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE';